import Alert from 'antd/lib/alert'
import './index.less'

export default Alert



// WEBPACK FOOTER //
// ./src/elements/alert/index.js